"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emit = exports.unsubscribe = exports.subscribe = void 0;

var _ProxyBus = require("./ProxyBus");

var _SimpleBus = require("./SimpleBus");

function getBus() {
  if (typeof window.OC !== 'undefined' && window.OC._eventBus && typeof window._nc_event_bus === 'undefined') {
    console.warn('found old event bus instance at OC._eventBus. Update your version!');
    window._nc_event_bus = window.OC._eventBus;
  } // Either use an existing event bus instance or create one


  if (typeof window._nc_event_bus !== 'undefined') {
    return new _ProxyBus.ProxyBus(window._nc_event_bus);
  } else {
    return window._nc_event_bus = new _SimpleBus.SimpleBus();
  }
}

var bus = getBus();
var subscribe = bus.subscribe.bind(bus);
exports.subscribe = subscribe;
var unsubscribe = bus.unsubscribe.bind(bus);
exports.unsubscribe = unsubscribe;
var emit = bus.emit.bind(bus);
exports.emit = emit;
//# sourceMappingURL=index.js.map